import type {
  IAppEvent,
  ICreateAppEventPayload,
  IDeleteAppEventPayload,
  IGetAppEventsPayload,
  IUpdateAppEventPayload,
} from '~/types/event'

import config from '~/config'
import { paramsSerializer } from '~/utils/api'
import { request } from '~/utils/request'

/** @doc https://app-dev-europe-west9-1058312231336.europe-west9.run.app/#get-/app/-appKey-/device-type/-deviceType-/event */
export const getAppEvents = ({ appKey, deviceType, ...queryParams }: IGetAppEventsPayload): Promise<IAppEvent[]> => {
  const formattedParams = {
    event_types: queryParams?.eventTypes,
    from: queryParams?.startDate,
    limit: queryParams?.limit,
    to: queryParams?.endDate,
  }

  return request({
    method: 'GET',
    url: `${config.APP_API}/app/${appKey}/device-type/${deviceType}/event?${paramsSerializer(formattedParams)}`,
  })
}

/** @doc https://app-dev-europe-west9-1058312231336.europe-west9.run.app/#post-/app/-appKey-/device-type/-deviceType-/event */
export const createAppEvent = ({
  appKey,
  date,
  deviceType,
  eventType,
  value,
}: ICreateAppEventPayload): Promise<IAppEvent> => {
  return request({
    data: {
      date,
      event_type: eventType,
      value,
    },
    method: 'POST',
    url: `${config.APP_API}/app/${appKey}/device-type/${deviceType}/event`,
  })
}

/** @doc https://app-dev-europe-west9-1058312231336.europe-west9.run.app/#put-/app/-appKey-/device-type/-deviceType-/event/-eventID- */
export const updateAppEvent = ({
  appKey,
  date,
  deviceType,
  eventId,
  eventType,
  value,
}: IUpdateAppEventPayload): Promise<IAppEvent> => {
  return request({
    data: {
      date,
      event_type: eventType,
      value,
    },
    method: 'PUT',
    url: `${config.APP_API}/app/${appKey}/device-type/${deviceType}/event/${eventId}`,
  })
}

/** @doc https://app-dev-europe-west9-1058312231336.europe-west9.run.app/#delete-/app/-appKey-/device-type/-deviceType-/event/-eventID- */
export const deleteAppEvent = ({ appKey, deviceType, eventId }: IDeleteAppEventPayload): Promise<IAppEvent> => {
  return request({
    method: 'DELETE',
    url: `${config.APP_API}/app/${appKey}/device-type/${deviceType}/event/${eventId}`,
  })
}
